import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { CoreModule } from 'src/app/core/core.module';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { MessagesModule } from 'primeng/messages';
import { InputTextarea } from 'primeng/inputtextarea';
import { TemplatesRoutingModule } from './templates-routing.module';
import { TemplatesListComponent } from './templates-list/templates-list.component';
import { TemplatesDetailComponent } from './templates-detail/templates-detail.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { TemplateCompanyComponent } from './templates-detail/template-company/template-company.component';
import { TemplatesVariablesComponent } from './templates-detail/templates-variables/templates-variables.component';
import { RadioButtonModule } from 'primeng/radiobutton';


@NgModule({ declarations: [
        TemplatesListComponent,
        TemplatesDetailComponent,
        TemplateCompanyComponent,
        TemplatesVariablesComponent
    ], imports: [CoreModule,
        CommonModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PasswordModule,
        FormsModule,
        TableModule,
        CardModule,
        TabViewModule,
        CalendarModule,
        MessagesModule,
        TemplatesRoutingModule,
        ReactiveFormsModule,
        InputTextModule,
        InputSwitchModule,
        ConfirmDialogModule,
        DropdownModule,
        DynamicDialogModule,
        InputTextarea,
        EditorModule,
        FileUploadModule,
        MultiSelectModule,
        RadioButtonModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class TemplatesModule { }
